<div class="app-content">
  <div class="image-container">
    <img src="/assets/portfolio.png" alt="Portfolio image" />
  </div>
</div>
